export enum CtxCaseMode {
  camelToSnake,
  snakeToCamel,
  none,
}
